var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.194 13.193a1.687 1.687 0 10-2.387-2.386 1.687 1.687 0 002.386 2.386zM17.17 14.784a1.687 1.687 0 11-2.386 2.387 1.687 1.687 0 012.386-2.387zM9.216 9.216a1.687 1.687 0 10-2.387-2.387 1.687 1.687 0 002.387 2.387z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm1.5 15.5v-15h15v15h-15z",
    fill: "currentColor"
  })));
}
SvgCasino.displayName = 'Casino';
export default SvgCasino;